import { useEffect, useState } from 'react';
import { authApi } from '../api/auth';

/**
 * Включён ли демо-режим на этом инстансе. Узнаётся в рантайме через
 * `GET /auth/demo/status` (образ веба единый для прода и демо, поэтому
 * режим нельзя зашить на этапе сборки). Результат кешируется на время
 * жизни вкладки.
 */
let cached: boolean | null = null;
let inflight: Promise<boolean> | null = null;

export function fetchDemoMode(): Promise<boolean> {
  if (cached !== null) return Promise.resolve(cached);
  if (!inflight) {
    inflight = authApi
      .demoStatus()
      .then((r) => {
        cached = r.demoMode;
        return cached;
      })
      .catch(() => {
        cached = false;
        return false;
      })
      .finally(() => {
        inflight = null;
      });
  }
  return inflight;
}

export function useDemoMode(): boolean {
  const [demo, setDemo] = useState<boolean>(cached ?? false);
  useEffect(() => {
    let cancelled = false;
    void fetchDemoMode().then((v) => {
      if (!cancelled) setDemo(v);
    });
    return () => {
      cancelled = true;
    };
  }, []);
  return demo;
}
